import { Pipe, PipeTransform } from '@angular/core';

import { environment as ENV } from '@environment';

@Pipe({
  name: 'baseImage',
  standalone: false
})
export class BaseImagePipe implements PipeTransform {

  public baseUrl: string = ENV.resources.base_lambda_img;
  public noPhotoUrl: string = 'web/no-photo.svg';
  private noImage: string = ENV.resources.base_lambda_img + this.noPhotoUrl;

  constructor() { }

  transform(value: string, folder: string, dimension?: string, extension?: string, quality?: string, nocache?: boolean): string {
    const urlBase = this.url(value, folder, this.params(dimension, extension, quality, nocache));

    return (value === null || value === 'NO-IMAGE') ? this.noImage : urlBase;
  }

  public setBaseUrl(url: string): void {
    this.baseUrl = url;
  }

  private url(value: string, folder: string, params: string): string {
    if (folder) {
      return `${this.baseUrl}/${folder}/${value}${params}`;
    }
    return `${this.baseUrl}/${value}${params}`;
  }

  private params(dimension: string, extension: string, quality: string, nocache: boolean): string {
    const params: string[] = [];
    if (dimension) {
      params.push(`d=${dimension}`);
    }
    if (quality) {
      params.push(`q=${quality}`);
    }
    if (nocache) {
      params.push(`t=${Date.now()}`);
    }
    if (extension) {
      return `.${extension}?${params.join('&')}`;
    }
    return `?${params.join('&')}`;
  }
}
